// Components==============
import { faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SingleItemDropdown from 'components/UI/SingleItemDropdown';
import React, { useContext, useEffect, useState } from 'react';
import { GroupContext } from 'screens/Group';
import { useMediaQ } from 'utilities/useMediaQ';
import Row from './components/Row/Row';
import './Explorer.module.scss';
// =========================

const categories = [
    { name: 'Naam', key: 'name' },
    { name: 'Datum toegevoegd', key: 'date' },
    { name: 'Eigenaar', key: 'owner' },
];

const options = [
    { name: 'Naam oplopend', key: 'name', asc: true },
    { name: 'Naam aflopend', key: 'name', asc: false },
    { name: 'Datum oplopend', key: 'date', asc: true },
    { name: 'Datum aflopend', key: 'date', asc: false },
];

const getKeyForDocument = (doc) => {
    if (doc?.path) {
        return `file-${doc?.id}`;
    }
    return `folder-${doc?.id}`;
};

export default function Explorer() {
    const { documents, setOrderOn, orderOn } = useContext(GroupContext);
    const [selectedSortOption, setSelectedSortOption] = useState(
        'Naam oplopend'
    );

    useEffect(() => {
        const current = options.find((o) => o.name === selectedSortOption);
        setOrderOn({ key: current.key, asc: current.asc });
    }, [selectedSortOption]);

    const query = useMediaQ('min', 850);

    return (
        <div styleName="wrapper">
            {query ? (
                <div styleName="top">
                    {categories.map((cat) => (
                        <div
                            styleName="sort"
                            key={cat.key}
                            onClick={() =>
                                setOrderOn((prev) =>
                                    prev.key === cat.key
                                        ? { key: cat.key, asc: !prev.asc }
                                        : { key: cat.key, asc: true }
                                )
                            }
                        >
                            {cat.name}
                            <div
                                styleName={`sort-icon ${
                                    cat.key === orderOn.key ? ' active' : ''
                                } ${orderOn.asc ? 'asc' : 'desc'}`}
                            >
                                <FontAwesomeIcon
                                    icon={faSortUp}
                                    styleName="up"
                                />
                                <FontAwesomeIcon
                                    icon={faSortDown}
                                    styleName="down"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <SingleItemDropdown
                    text={selectedSortOption}
                    options={options.map((e) => e.name)}
                    selected={selectedSortOption}
                    setSelected={setSelectedSortOption}
                    white
                />
            )}
            <div styleName="explorer">
                {documents.map((doc, i) => (
                    <Row
                        key={getKeyForDocument(doc)}
                        doc={doc}
                        lastItem={i === documents.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}
